import React from "react";
import { jwtDecode } from 'jwt-decode';
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { loginSuccess, setUnreadNotificationCount } from "../redux/actions/authActions";
import { fetchData, postRequest } from "../hooks/services/services";
import { showToast } from "../utils/toast";


const LoginWithApple = ({ loginTypeValue }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleAppleSuccess = async (credentialResponse) => {
    try {
      const decoded = jwtDecode(credentialResponse.credential);
      const { email, name, sub: apple_id } = decoded;

      const payload = {
        email,
        name,
        type: loginTypeValue,
        social_type: 'apple',
      };

      const response = await postRequest("api/v1/sessions/social_login", payload);
      if (response.status === 200) {
        const token = response.headers.get("Authorization");
        const id = response.headers.get("id");
        const responseData = await response.json();

        dispatch(
          loginSuccess({
            token: token,
            id: id,
            user_type: payload.type,
          })
        );

        const notifRes = await fetchData("api/v1/notifications/unread_count", {
          Authorization: token,
        });
        const notifData = await notifRes.json();
        dispatch(setUnreadNotificationCount(notifData?.unread_count || 0));

        const newUser = responseData?.new_user;
        const profileCompleted = responseData?.data?.profile_completed;

        if (payload.type === "Contractor") {
          if (!profileCompleted && newUser) {
            navigate("/buildyourprofile", {
              state: {
                userType: payload.type,
                email: payload.email,
                isGoogleLogin: false,
              },
            });
          } else if (!profileCompleted && !newUser) {
            navigate("/plan");
          } else if (profileCompleted && !newUser) {
            navigate("/contractor/profile");
          }
        } else if (payload.type === "Athlete") {
          if (!profileCompleted) {
            navigate("/profile");
          } else {
            navigate("/athlete/myroadmap");
          }
        } else {
          navigate("/business/info");
        }

        showToast(responseData?.message || "Logged in successfully!", "success");
      }
    } catch (error) {
      console.error("Apple login error:", error);
      showToast(error?.message || "Apple login failed", "error");
    }
  };

  return (
    <button className="apple-button" onClick={() => {
      const mockCredential = {
        credential: jwtEncodeMockAppleUser({
          email: "Team@globalllife.com",
          name: "Apple User",
          sub: "apple-user-id-123",
        }),
      };
      handleAppleSuccess(mockCredential);
    }}>
      <img src="images/apple.svg" alt="Apple icon" />
      Apple
    </button>
  );
};

export default LoginWithApple;

const jwtEncodeMockAppleUser = ({ email, name, sub }) => {
  const payload = {
    email,
    name,
    sub,
  };
  return btoa(JSON.stringify({ alg: "none" })) + "." + btoa(JSON.stringify(payload)) + ".";
};
